exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  margin-top: 10vh;\n  display: inline-block;\n  width: 100%;\n  padding-top: 7px;\n  background-color: #faba19;\n  border-top: 5px solid #285d3e;\n  border-bottom: 5px solid #285d3e; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/shared/logo/logo.component.scss
// module id = ../../../../../src/app/pages/shared/logo/logo.component.scss
// module chunks = main